import * as React from 'react';
import { SVGProps } from 'react';

const IconLoadingSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M14.2 3.79c.214-.8-.261-1.635-1.084-1.728A10 10 0 1 0 21.31 8.35c-.302-.77-1.231-1.014-1.949-.6-.717.414-.945 1.33-.693 2.12a6.999 6.999 0 0 1-10.93 7.684 7 7 0 0 1 4.594-12.546c.828.04 1.654-.418 1.868-1.218Z" />
  </svg>
);
export default IconLoadingSizeM;
